import { BannerInfo } from 'bpm/models/bannerInfo'
import { KNOWLEDGEPOINT_CDN_URL } from 'bpm/shared/utils/urlUtils'

export const BannerInfoResolver = {
    bannerInfo: () =>
        ({
            __typename: 'bannerInfo-JeldWen',
            displayName: 'Jeld-Wen',
            subTitle: 'Jeld-Wen Windows and Doors',
            bannerImageUrl: `${KNOWLEDGEPOINT_CDN_URL}|/company_home_banner.png`,
        } as BannerInfo),
}
